import { tw } from "@careinfo/tailwind";
import { ColumnDef } from "@tanstack/react-table";
import { useState } from "react";
import Info from "../../components/Master/Info";
import APIS from "../../constant/Endpoint";
import EditIcon from "../../Icons/EditIcon";
import Button from "../Reusable/Button";
import DataTable from "../Reusable/Datatable";
import TableSearch from "../Reusable/Datatable/components/Search";
import PopupModal from "../Reusable/Modal";
import SwitchButton from "../Reusable/SwitchButton";
import EditProductGroup from "./EditProductGroup";
import ProductGroupForm from "./ProductGroup";
import { AccessControl } from "@careinfo/permission-required";

const ProductGroupList = ({ handleDelete, handleIsActive }) => {
  const [openCategoryFormPopup, setOpenCategoryFormPopup] = useState(false);
  const [openCategoryEditPopup, setOpenCategoryEditPopup] = useState(false);
  const [categoryData, setCategoryData] = useState(false);

  const columns: ColumnDef<any, any>[] = [
    {
      accessorKey: "name",
      header: "Name",
      cell: ({ row, getValue }: any) => {
        return <p className={tw`w-60`}>{getValue()}</p>;
      },
    },

    {
      accessorKey: "is_active",
      header: "Active",
      cell: ({ row, getValue }: any) => (
        <SwitchButton
          id={row?.original?.id}
          value={getValue()}
          disabled={false}
          onChange={handleIsActive}
        />
      ),
    },
    {
      accessorKey: "id",
      header: "Action",
      cell: ({ row, getValue }: any) => {
        return (
          <div className={tw`grid grid-cols-2 gap-x-4 items-center`}>
            <AccessControl allowedPermissions={["can_edit_product_group"]}>
              <button
                type="button"
                className={tw`focus:outline-none`}
                onClick={() => {
                  setCategoryData(row?.original);
                  setOpenCategoryEditPopup(!openCategoryEditPopup);
                }}
              >
                <EditIcon color={"var(--primary)"} />
              </button>
            </AccessControl>

            {/* <button
              type="button"
              className={tw`focus:outline-none w-6 h-6`}
              onClick={() => handleDelete(getValue())}
            >
              <DeleteIcon color={"var(--primary)"} />
            </button> */}
          </div>
        );
      },
    },
  ];

  const handleClosePopup = () => {
    setCategoryData(null);
    setOpenCategoryFormPopup(false);
    setOpenCategoryEditPopup(false);
  };

  return (
    <div>
      <Info />
      <div className={tw`space-y-4 mt-4`}>
        <div className={tw` flex gap-x-2`}>
          <AccessControl allowedPermissions={["can_search_product_group"]}>
            <TableSearch />
          </AccessControl>

          <div className={tw`w-32`}>
            <AccessControl allowedPermissions={["can_add_product_group"]}>
              <Button
                label="Add New "
                type="button"
                onClick={() => setOpenCategoryFormPopup(!openCategoryFormPopup)}
              />
            </AccessControl>
          </div>
        </div>
        <DataTable
          columns={columns}
          queryKey={"category"}
          url={APIS.CATEGORY}
          params={{}}
          customSearch={true}
          tableName="category"
        />
        <PopupModal
          isOpen={openCategoryFormPopup}
          setIsOpen={handleClosePopup}
          title="Product Group"
        >
          <div className={tw`w-[400px]`}>
            <ProductGroupForm
              setOpenCategoryFormPopup={setOpenCategoryFormPopup}
              data={categoryData}
            />
          </div>
        </PopupModal>
        <PopupModal
          isOpen={openCategoryEditPopup}
          setIsOpen={handleClosePopup}
          title="Product Group"
        >
          <div className={tw`w-[400px]`}>
            <EditProductGroup
              setOpenCategoryFormPopup={setOpenCategoryEditPopup}
              data={categoryData}
            />
          </div>
        </PopupModal>
      </div>
    </div>
  );
};

export default ProductGroupList;
